import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { ListPaymentModeLevel2CountryMappingResponse, ListPaymentModeMastersResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { Observable, throwError, } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
@Injectable({
  providedIn: 'root',
})
export class PaymentModeService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  createPaymentMode(tenantId: number, createPaymentMode: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.CREATE_PAYMENT_MODE
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        createPaymentMode,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPaymentMode(tenantId: number, allParams: Array<string> = []) {

    let parsedParams = new HttpParams()
    if (allParams.length > 0) {

      allParams.forEach((p: any) => {

        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.GET_PAYMENT_MODES
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get(
        url,
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updatePaymentMode(tenantId: number, paymentModId: number, data: any) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.UPDATE_PAYMENT_MODE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{mode_id}', paymentModId.toString());
    return this.http
      .put(
        url,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markActive(tenantId: number, paymentModId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.MARK_PAYMENT_MODE_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{mode_id}', paymentModId.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  delete(tenantId: number, paymentModId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.DELETE_PAYMENT_MODE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{mode_id}', paymentModId.toString());
    return this.http
      .delete(
        url,

        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(tenantId: number, paymentModId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.MARK_PAYMENT_MODE_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{mode_id}', paymentModId.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSinglePaymentMode(tenantId: number, paymentModId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.GET_PAYMENT_MODE_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{mode_id}', paymentModId.toString());
    return this.http
      .get(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  listPaymentMode(tenantId: number): Observable<ListPaymentModeMastersResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PAYMENT.GET_PAYMENT_MODES
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  listPaymentModeLevel2(countryCode: string): Observable<ListPaymentModeLevel2CountryMappingResponse> {
    return this.http.get(`${environment.BASE_URL}/open/countries/${countryCode}/offlinepaymentmode`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
